export function isPC() {
    let sUserAgent = navigator.userAgent.toLocaleLowerCase();
    if (/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(sUserAgent)) {
        console.log('移动端');
        return false;

    } else {
        //跳转pc端页面
        console.log('PC端');
        return true;

    }
}
